module.exports = __webpack_public_path__ + "static/media/smartx_disabled.def62cdf.svg";